import { useMutation, useQuery, useQueryClient } from "react-query";
import { deleteManufacturer, getManufacturerList } from "../../services/manufacturers";
import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import config from "../../config";
import { useSnackbar } from "notistack";
import { Modal } from "react-bootstrap";
import { convertDate } from "../../utils";

const DeleteManufacturerModal = ({ show, handleClose, handleDelete }) => {
  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>Delete Manufacturer</Modal.Title>
      </Modal.Header>
      <Modal.Footer>
        <button
          type="button"
          className="btn btn-primary"
          onClick={handleDelete}
        >
          Confirm
        </button>
        <button type="button" className="btn btn-danger" onClick={handleClose}>
          Cancel
        </button>
      </Modal.Footer>
    </Modal>
  );
};

function Manufacturers() {
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteManufacturerId, setDeleteManufacturerId] = useState(null);

  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const queryClient = useQueryClient();

  useEffect(() => {
    // Save scroll position before page is unloaded
    window.addEventListener("scroll", () => {
      sessionStorage.setItem("scrollPositionManufacturer", window.scrollY);
    });

    // Cleanup
    return () => {
      window.removeEventListener("beforeunload", () => {
        sessionStorage.setItem("scrollPositionManufacturer", window.scrollY);
      });
    };
  }, []);

  useEffect(() => {
    // Restore scroll position
    if (sessionStorage.getItem("scrollPositionManufacturer")) {
      window.scrollTo(0, sessionStorage.getItem("scrollPositionManufacturer"));
    }
  });

  const manufacturerListQuery = useQuery({
    queryKey: ["manufacturerList"],
    queryFn: getManufacturerList,
  });

  const manufacturerList = manufacturerListQuery.data || [];

  const deleteManufacturerMutation = useMutation({
    mutationFn: deleteManufacturer,
    onError(error) {
      enqueueSnackbar(error.message, { variant: "error" });
    },
    onSuccess(data) {
      enqueueSnackbar("Delete Manufacturer success!", { variant: "success" });
      queryClient.invalidateQueries("manufacturerList");
      setShowDeleteModal(false);
    },
  });

  const handleRedirectAddManufacturer = () => {
    navigate(config.routes.addManufacturer);
  };

  const handleShowDetail = (id) => {
    navigate(`${config.routes.manufacturer}/${id}`);
  };

  const handleShowDeleteModal = (id) => {
    setShowDeleteModal(true);
    setDeleteManufacturerId(id);
  };

  const handleDeleteManufacturer = () => {
    deleteManufacturerMutation.mutate(deleteManufacturerId);
  };

  return (
    <div>
      <h3 className="text-center">Manufacturer List</h3>
      <div className="d-flex justify-content-between">
        <button
          type="button"
          className="btn btn-primary"
          onClick={handleRedirectAddManufacturer}
        >
          Add Manufacturer
        </button>
      </div>
      <div>
        {manufacturerListQuery.isLoading ? (
          "Loading"
        ) : (
          <table className="table">
            <thead>
              <tr>
                <th scope="col">No</th>
                <th scope="col">Manufacturer Name</th>
                <th scope="col">Order Num</th>
                <th scope="col">Last modified at</th>
                <th scope="col">Modified by</th>
                <th scope="col">Delete</th>
              </tr>
            </thead>
            <tbody>
              {manufacturerList.map((manufacturer, index) => (
                <tr key={manufacturer.manufacturer_id}>
                  <th scope="row">{index + 1}</th>
                  <td onClick={() => handleShowDetail(manufacturer.manufacturer_id)}>
                    <Link>{manufacturer.manufacturer_name}</Link>
                  </td>
                  <td>{manufacturer.order_num}</td>
                  <td>{convertDate(manufacturer.updated_at)}</td>
                  <td>{manufacturer.updated_by}</td>
                  <td>
                    <i
                      className="bi bi-trash3"
                      style={{ cursor: "pointer" }}
                      onClick={() =>
                        handleShowDeleteModal(manufacturer.manufacturer_id)
                      }
                    ></i>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      <DeleteManufacturerModal
        show={showDeleteModal}
        handleClose={() => setShowDeleteModal(false)}
        handleDelete={handleDeleteManufacturer}
      />
    </div>
  );
}

export default Manufacturers;
